<template>
  <vx-tooltip :text="name" position="right" class="switcher-app" color="#00B5FF">
    <div class="ps-sidebar-item-block" :class="pageNames.includes($route.name) ? 'active-platform' : ''">
      <div class="ps-line-active"></div>
      <vs-avatar size="large" color="transparent" :src="icon" @click="$router.push(launchPath)"/>
    </div>
  </vx-tooltip>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    pageNames: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    launchPath: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.switcher-app {
  user-select: none;
}
</style>
